Ext.define('SA.model.createimport.ColumnStepErrors', {
    singleton: true,

    COLUMN_WITHOUT_TYPE: 'Select the Data Type for each column.',
    DATA_COLUMN_WITHOUT_FORMAT: 'Select the Data Format for each data column.',
    DUPLICATE_FRIENDLY_NAMES: 'Multiple columns can’t be given the same Friendly Name.',
    FRIENDLY_NAME_DEFAULTED_NAME_CONFLICT: 'Friendly Names can’t be the same as Column Names.',

    FILE_WITH_MULTIPLE_LOCATION_COLUMNS: {
        ONE_FILE: 'Only one Location ID column may be specified.',
        MULTI_FILE: 'Each file must have only a single Location ID column specified.'
    },

    FILE_WITHOUT_DATA_COLUMNS: {
        ONE_FILE: 'Specify at least one column of data to import.',
        MULTI_FILE: 'Each file must have at least one column specified as containing data to import.'
    },

    FILE_WITHOUT_LOCATION_COLUMN: {
        ONE_FILE: 'Specify a Location ID column.',
        MULTI_FILE: 'Each file must have a Location ID column specified.'
    },

    MALFORMED_LOCATION: {
        ONE_FILE: new Ext.XTemplate('The {unitName} values in your file must be specified as {formatDescription}.'),
        MULTI_FILE: new Ext.XTemplate('In ‘{fileName}’, the {unitName} values must be specified as {formatDescription}.')
    },

    NON_NUMERIC_DATA: {
        ONE_FILE: new Ext.XTemplate('In your file’s {headerNames:commaList("and", "column")}, one or more values are non-numeric.'),
        MULTI_FILE: new Ext.XTemplate('In ‘{fileName}’, one or more values in the {headerNames:commaList("and", "column")} are non-numeric.')
    }
});